<div class="error {{theme}}" [ngStyle]="customStyles">
  <i class="error__msg">{{
    message | translate : { comparisonFieldName: comparisonFieldName }
  }}</i>
</div>
